<template>
  <rules-list v-if="!isSearch"></rules-list>
  <search-page v-else></search-page>
</template>


<script>
    import RulesList from '@/components/moderator/Rules.vue';
    import SearchPage from '@/components/moderator/SearchPage.vue';
    import {mapState} from 'vuex';

    export default {
        name: "Rules",
        components: {
            RulesList,
            SearchPage
        },
        data: function(){
          return {};
        },
        computed: {
          ...mapState({
                isSearch: state => state.rules.isSearch,
            }),
        },
        methods:{
        },
        mounted() {
        },
    }
</script>
